export default __webpack_public_path__ + "static/media/05_photo.fe88ef14.jpeg";